export class DeviceActivityColors {
    static readonly GREEN = '#5CA909';
    static readonly AMBER = '#F5A623';
    static readonly RED   = '#D0021B';
    static readonly GRAY  = '#949499';
}